// All URLs are relative to the page origin so the app works on any host/IP.
// nginx proxies /api/, /ws/, /clips/, /annotated/, etc. to the backend.
export const API = '/api';
export const API_BASE = '';   // prefix for /clips/…, /annotated/…, etc.

const wsProto = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
export const WS_URL = `${wsProto}//${window.location.host}/ws/stream`;
